import { useLauncherStore } from "@/app/[tenantId]/[messengerId]/[hostConfig]/lib/client/contexts/LauncherStoreContext";

export default function InlineStyles() {
  const theme = useLauncherStore((state) => state.theme);

  return (
    <style>
      {`
        :root {
            --color900: ${theme.light.actionColorScale[900]};
            --color800: ${theme.light.actionColorScale[800]};
            --color700: ${theme.light.actionColorScale[700]};
            --color600: ${theme.light.actionColorScale[600]};
            --color500: ${theme.light.actionColorScale[500]};
            --color400: ${theme.light.actionColorScale[400]};
            --color300: ${theme.light.actionColorScale[300]};
            --color200: ${theme.light.actionColorScale[200]};
            --color100: ${theme.light.actionColorScale[100]};
            --color50: ${theme.light.actionColorScale[50]};
            --contrastText: ${theme.light.contrastTextColor};

            --launcherButtonColor: ${theme.light.launcherButtonColor};

            --bgTextColor: ${theme.light.background.textColor};
            --bgColor: ${theme.light.background.color};
            --bgStart: ${theme.light.background.bgStart};
            --bgEnd: ${theme.light.background.bgEnd};
        }
        :root .dark {
            --color900: ${theme.dark.actionColorScale[900]};
            --color800: ${theme.dark.actionColorScale[800]};
            --color700: ${theme.dark.actionColorScale[700]};
            --color600: ${theme.dark.actionColorScale[600]};
            --color500: ${theme.dark.actionColorScale[500]};
            --color400: ${theme.dark.actionColorScale[400]};
            --color300: ${theme.dark.actionColorScale[300]};
            --color200: ${theme.dark.actionColorScale[200]};
            --color100: ${theme.dark.actionColorScale[100]};
            --color50: ${theme.dark.actionColorScale[50]};
            --contrastText: ${theme.dark.contrastTextColor};

            --launcherButtonColor: ${theme.dark.launcherButtonColor};

            --bgTextColor: ${theme.dark.background.textColor};
            --bgColor: ${theme.dark.background.color};
            --bgStart: ${theme.dark.background.bgStart};
            --bgEnd: ${theme.dark.background.bgEnd};
        }
      `}
    </style>
  );
}
